import React from 'react'
import { Select, Tag } from 'antd'

const { Option } = Select

class SingleSelectGeneric extends React.Component {
  constructor(props) {
    super(props)
    this.selectoptions = []
    this.props.selectoptions.forEach((option) => {
        this.selectoptions.push(<Option key={option.key}>{option.label}</Option>)
    })

  }

  render() {
    function tagRender(props) {
      const { value, closable, onClose } = props
      const onPreventMouseDown = (event) => {
        event.preventDefault()
        event.stopPropagation()
      }
      return (
        <Tag onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
          {value}
        </Tag>
      )
    }

    return (
      <Select
        placeholder={this.props.placeholder}
        {...this.props}
        mode='single'
        allowClear
        showArrow
        tagRender={tagRender}
        style={{ width: '100%', marginBottom:'16px'}}
      >
        {this.selectoptions}
      </Select>
    )
  }
}

export default SingleSelectGeneric
